/* ============================================================================
   HDZP · OBALUS product page runtime (owner: pdp-core). Vanilla, no libraries.
   Depends on window.HDZB (assets/hdzb.js, loaded earlier with defer) for money, cart, radios, steppers, videos, toasts.
   Wires:
     [data-hdzp-gallery]  swipe track · counter · thumbs · zoom lightbox · variant → slide sync
     [data-hdzp-buy]      option pickers → variant (price · availability · url · gallery) · add-to-cart per mode
                          kaching → the Kaching Bundles widget owns the payload (it hooks input[name=id]; we keep it in sync
                                    and mirror the widget's own hand selects back into the segmented control)
                          bogo    → native automatic BOGO: two units (Right / Left / One of each) via HDZB.cart.add
                          native  → plain product: HDZB.cart.add({id, quantity})
     [data-hdzp-sticky]   sticky bar: visible whenever the buy box button is off screen (above OR below)
     [data-hdzp-recs]     "You may also like" via the Section Rendering API
     .hdzp-vid            content videos keep their natural ratio (--ar set on loadedmetadata)
   Money: never '$' + number. HDZB.money(cents) formats in the active currency (Shopify Markets).
   ========================================================================== */
(function () {
  'use strict';
  if (window.HDZP && window.HDZP.__v) return;
  var P = { __v: '1.3.0' };
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function on(el, ev, fn, o) { el.addEventListener(ev, fn, o || false); }
  function H() { return window.HDZB || null; }
  function money(cents, o) { var h = H(); if (h && h.money) return h.money(cents, o); return String(cents); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }

  /* ---------------- zoom lightbox (one per page) ---------------- */
  var zoom = null;
  function buildZoom() {
    if (zoom) return zoom;
    var root = document.createElement('div');
    root.className = 'hdzb hdzp-zoom';
    root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'Product photo');
    root.innerHTML =
      '<div class="hdzp-zoom__bar"><span class="hdzp-zoom__n" data-n></span><span class="hdzp-zoom__hint">Pinch or tap to zoom</span><button type="button" class="hdzb-iconbtn" data-close aria-label="Close">' +
      '<svg class="hdzb-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button></div>' +
      '<div class="hdzp-zoom__body"><img alt="" data-img></div>' +
      '<div class="hdzp-zoom__nav"><button type="button" class="hdzb-btn hdzb-btn--outline hdzb-btn--sm" data-prev>Previous</button><button type="button" class="hdzb-btn hdzb-btn--sm" data-next>Next</button></div>';
    document.body.appendChild(root);
    var img = $('[data-img]', root), n = $('[data-n]', root), body = $('.hdzp-zoom__body', root);
    var list = [], idx = 0, release = null, lastTap = 0;
    function show(i) {
      if (!list.length) return;
      idx = (i + list.length) % list.length;
      root.classList.remove('is-zoomed');
      img.src = list[idx].src; img.alt = list[idx].alt || '';
      n.textContent = (idx + 1) + ' / ' + list.length;
      body.scrollTo(0, 0);
    }
    function close() {
      root.classList.remove('is-on'); root.classList.remove('is-zoomed');
      var h = H(); if (h && h.lockScroll) h.lockScroll(false); else document.documentElement.style.overflow = '';
      if (release) { release(); release = null; }
    }
    function toggleZoom(ev) {
      var was = root.classList.contains('is-zoomed');
      root.classList.toggle('is-zoomed');
      if (!was && ev) {
        var r = body.getBoundingClientRect();
        var fx = (ev.clientX - r.left) / r.width, fy = (ev.clientY - r.top) / r.height;
        requestAnimationFrame(function () { body.scrollLeft = (body.scrollWidth - body.clientWidth) * fx; body.scrollTop = (body.scrollHeight - body.clientHeight) * fy; });
      }
    }
    on($('[data-close]', root), 'click', close);
    on($('[data-prev]', root), 'click', function () { show(idx - 1); });
    on($('[data-next]', root), 'click', function () { show(idx + 1); });
    on(img, 'click', function (e) { toggleZoom(e); });
    on(img, 'touchend', function (e) { var t = Date.now(); if (t - lastTap < 320) { e.preventDefault(); toggleZoom(e.changedTouches && e.changedTouches[0]); } lastTap = t; }, { passive: false });
    on(root, 'keydown', function (e) { if (e.key === 'ArrowLeft') show(idx - 1); else if (e.key === 'ArrowRight') show(idx + 1); else if (e.key === 'Escape') close(); });
    var sx = null;
    on(body, 'touchstart', function (e) { sx = root.classList.contains('is-zoomed') ? null : e.touches[0].clientX; }, { passive: true });
    on(body, 'touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 60) show(idx + (dx < 0 ? 1 : -1)); sx = null; }, { passive: true });
    zoom = {
      open: function (items, i) {
        list = items; root.classList.add('is-on'); show(i || 0);
        var h = H();
        if (h && h.lockScroll) h.lockScroll(true); else document.documentElement.style.overflow = 'hidden';
        if (h && h.trapFocus) release = h.trapFocus(root, { onEscape: close, initial: '[data-close]' });
      },
      close: close
    };
    return zoom;
  }

  /* ---------------- gallery ---------------- */
  P.initGallery = function (g) {
    if (g.__hdzp) return; g.__hdzp = true;
    var track = $('[data-hdzp-track]', g), slides = $$('[data-hdzp-slide]', g), thumbs = $$('[data-hdzp-thumb]', g), count = $('[data-hdzp-count]', g), zoomBtn = $('[data-hdzp-zoom]', g);
    if (!track || !slides.length) return;
    var cur = 0, at = Number(g.getAttribute('data-media-at')) || 0, off = Number(g.getAttribute('data-media-offset')) || 0, lead = Number(g.getAttribute('data-media-lead')) || 0;
    function setCur(i) {
      cur = Math.max(0, Math.min(slides.length - 1, i));
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === cur); t.setAttribute('aria-selected', k === cur ? 'true' : 'false'); });
      if (count) count.textContent = (cur + 1) + ' / ' + slides.length;
      var th = thumbs[cur];
      if (th && th.parentNode && th.parentNode.scrollWidth > th.parentNode.clientWidth) { try { th.parentNode.scrollTo({ left: th.offsetLeft - th.parentNode.clientWidth / 2 + th.offsetWidth / 2, behavior: 'smooth' }); } catch (e) { } }
      if (zoomBtn) zoomBtn.style.display = slides[cur].hasAttribute('data-video') ? 'none' : '';
    }
    function goTo(i, smooth) { var s = slides[Math.max(0, Math.min(slides.length - 1, i))]; if (!s) return; track.scrollTo({ left: s.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' }); setCur(i); }
    on(track, 'scroll', debounce(function () { var w = track.clientWidth || 1; setCur(Math.round(track.scrollLeft / w)); }, 60), { passive: true });
    thumbs.forEach(function (t, k) { on(t, 'click', function () { goTo(k); }); });
    function items() { return slides.filter(function (s) { return !s.hasAttribute('data-video'); }).map(function (s) { var im = $('img', s) || {}; return { src: s.getAttribute('data-full') || im.currentSrc || im.src || '', alt: im.alt || '' }; }); }
    function openZoom() { var s = slides[cur]; if (!s || s.hasAttribute('data-video')) return; var list = items(); if (!list.length) return; var i = slides.slice(0, cur).filter(function (x) { return !x.hasAttribute('data-video'); }).length; buildZoom().open(list, i); }
    slides.forEach(function (s) { if (!s.hasAttribute('data-video')) on(s, 'click', openZoom); });
    if (zoomBtn) on(zoomBtn, 'click', openZoom);
    on(g, 'keydown', function (e) { if (e.target !== g) return; if (e.key === 'ArrowLeft') goTo(cur - 1); else if (e.key === 'ArrowRight') goTo(cur + 1); });
    g.__goTo = goTo;
    /* product-media index (variant.featured_media) → slide index, accounting for the inserted lifestyle files / video,
       slides an image test put in front (data-media-lead) and a test set with no product media (data-media-sync="off") */
    g.__goToMedia = function (mi) { if (mi == null || mi < 0 || g.getAttribute('data-media-sync') === 'off') return; goTo((mi >= at ? mi + off : mi) + lead); };
    setCur(0);
  };

  /* ---------------- buy box ---------------- */
  P.initBuy = function (box) {
    if (box.__hdzp) return; box.__hdzp = true;
    var mode = box.getAttribute('data-mode') || 'native';
    var dataEl = $('[data-hdzp-product]', box);
    var data = null; try { data = JSON.parse(dataEl ? dataEl.textContent : '{}'); } catch (e) { data = null; }
    var form = $('[data-hdzp-form]', box), idInput = form ? $('[data-hdzp-id]', form) : null;
    var btn = $('[data-hdzp-atc]', box), err = $('[data-hdzp-err]', box);
    var priceEl = box.getAttribute('data-price') ? $(box.getAttribute('data-price')) : null;
    var gallery = box.getAttribute('data-gallery') ? $(box.getAttribute('data-gallery')) : null;
    var groups = $$('[data-hdzp-opt]', box);
    var handIdx = data && typeof data.hand === 'number' ? data.hand : -1;
    var labelDefault = btn ? btn.innerHTML : '';
    var lastVariant = null;

    function groupValue(gEl) {
      if (gEl.tagName === 'SELECT') return gEl.value;
      var onEl = $('[role="radio"][aria-checked="true"]', gEl) || $('[role="radio"].is-on', gEl);
      return onEl ? onEl.getAttribute('data-value') : null;
    }
    function handValue(side) {
      /* the option value that contains 'right' / 'left' */
      if (!data || handIdx < 0) return null;
      var vals = {};
      data.variants.forEach(function (v) { var o = v.opts[handIdx]; if (o) vals[o] = 1; });
      var keys = Object.keys(vals);
      return keys.filter(function (k) { return k.toLowerCase().indexOf(side) > -1; })[0] || null;
    }
    function selectedOptions(sideForMix) {
      var vals = [];
      groups.forEach(function (gEl) {
        var idx = Number(gEl.getAttribute('data-index')), v = groupValue(gEl);
        if (v === '__mix__') v = handValue(sideForMix || 'right');
        vals[idx] = v;
      });
      return vals;
    }
    function findVariant(vals) {
      if (!data || !data.variants) return null;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var k = 0; k < v.opts.length; k++) { if (vals[k] != null && vals[k] !== v.opts[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function currentVariant() { return findVariant(selectedOptions()) || (data && data.variants && data.variants[0]) || null; }
    function isMix() { return groups.some(function (g) { return groupValue(g) === '__mix__'; }); }

    function paintPrice(v) {
      if (!v) return;
      var saving = (v.compare || 0) > v.price ? v.compare - v.price : 0;
      if (priceEl) {
        var now = $('[data-hdzb-price-now]', priceEl), was = $('[data-hdzb-price-was]', priceEl), save = $('[data-hdzb-price-save]', priceEl);
        priceEl.setAttribute('data-cents', v.price); priceEl.setAttribute('data-compare', v.compare || 0);
        if (now) now.textContent = money(v.price);
        if (was) { was.style.display = saving > 0 ? '' : 'none'; if (saving > 0) was.textContent = money(v.compare); }
        if (save) { save.style.display = saving > 0 ? '' : 'none'; if (saving > 0) save.textContent = 'Save ' + money(saving, { trim: true }); }
      }
      if (!box.hasAttribute('data-repeat')) {
        $$('[data-hdzp-sticky-price]').forEach(function (el) { el.setAttribute('data-cents', v.price); el.textContent = money(v.price); });
        $$('[data-hdzp-sticky-was]').forEach(function (el) { el.style.display = saving > 0 ? '' : 'none'; if (saving > 0) { el.setAttribute('data-cents', v.compare); el.textContent = money(v.compare); } });
      }
    }
    function paintAvailability(v) {
      if (!btn) return;
      var avail = !v || v.available !== false;
      if (mode === 'bogo' && isMix()) { var v2 = findVariant(selectedOptions('left')); if (v2 && v2.available === false) avail = false; }
      btn.disabled = !avail;
      if (!avail) { btn.innerHTML = 'Sold out'; btn.setAttribute('aria-disabled', 'true'); }
      else if (!btn.classList.contains('is-busy')) { btn.innerHTML = labelDefault; btn.removeAttribute('aria-disabled'); }
    }
    function paintPills(vals) {
      groups.forEach(function (gEl) {
        if (gEl.tagName === 'SELECT' || !data) return;
        var idx = Number(gEl.getAttribute('data-index'));
        $$('[role="radio"]', gEl).forEach(function (o) {
          var val = o.getAttribute('data-value'); if (val === '__mix__') return;
          var test = vals.slice(); test[idx] = val;
          var v = findVariant(test);
          o.classList.toggle('is-off', !v || v.available === false);
        });
      });
    }
    function syncUrl(v) {
      if (!v || !window.history || !window.history.replaceState || box.hasAttribute('data-repeat')) return;
      if (data && data.handle && window.location.pathname.indexOf('/products/' + data.handle) < 0) return; /* the box sells another product (commerce parity) — leave the URL alone */
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) { }
    }
    function syncGallery(v) { if (!gallery || !gallery.__goToMedia || !v || v.media == null) return; gallery.__goToMedia(Number(v.media)); }
    function apply(source) {
      var vals = selectedOptions(), v = findVariant(vals);
      if (v && idInput && String(idInput.value) !== String(v.id)) idInput.value = String(v.id); /* Kaching hooks this setter → the widget follows the hand */
      paintPrice(v); paintAvailability(v); paintPills(vals);
      if (source !== 'init' && v && (!lastVariant || lastVariant.id !== v.id)) { syncUrl(v); syncGallery(v); }
      lastVariant = v;
      box.dispatchEvent(new CustomEvent('hdzp:variant', { bubbles: true, detail: { variant: v, box: box, mix: isMix() } }));
    }
    on(box, 'hdzb:change', function (e) { if (e.target && e.target.hasAttribute('data-hdzp-opt')) apply('change'); });
    groups.forEach(function (gEl) { if (gEl.tagName === 'SELECT') on(gEl, 'change', function () { apply('change'); }); });

    /* Kaching: mirror the widget's own hand selects (inside the tier cards) back into the segmented control */
    if (mode === 'kaching' && handIdx >= 0) {
      on(box, 'change', function (e) {
        var sel = e.target;
        if (!sel || sel.tagName !== 'SELECT' || !sel.className || String(sel.className).indexOf('kaching-bundles__bar-variant-select') < 0) return;
        var val = sel.value, hand = groups.filter(function (g) { return g.hasAttribute('data-hand'); })[0];
        if (!hand || !val) return;
        var target = $$('[role="radio"]', hand).filter(function (o) { return o.getAttribute('data-value') === val; })[0];
        if (!target || target.classList.contains('is-on')) return;
        /* first select of the widget = the reel that mirrors the picker; later ones are per-unit choices (mixing hands is allowed) */
        var all = $$('.kaching-bundles__bar--selected select.kaching-bundles__bar-variant-select', box);
        if (all.length && all[0] !== sel) return;
        $$('[role="radio"]', hand).forEach(function (o) { var onIt = o === target; o.classList.toggle('is-on', onIt); o.setAttribute('aria-checked', onIt ? 'true' : 'false'); });
        var vals = selectedOptions(), v = findVariant(vals);
        paintPrice(v); paintPills(vals); syncGallery(v); lastVariant = v;
      }, true);
    }

    /* Kaching: our Right/Left choice applies to EVERY reel of the selected tier. Kaching itself only follows input[name=id]
       for the page's own product, so on a tier like "Cobra + FREE Obalus Baitcast Duo" the free reel stayed right-handed.
       Re-applied when the tier changes (Kaching re-renders the tier with default selects); stops as soon as the buyer
       changes one of Kaching's own per-reel selects (mixing hands on purpose), until he taps our control again. */
    if (mode === 'kaching' && handIdx >= 0) {
      var sideOf = function (v) { v = String(v || '').toLowerCase(); return v.indexOf('left') > -1 ? 'left' : (v.indexOf('right') > -1 ? 'right' : null); };
      var handGroup = groups.filter(function (g) { return g.hasAttribute('data-hand'); })[0];
      var handSide = handGroup ? sideOf(groupValue(handGroup)) : null, manualMix = false, lastBar = null;
      var syncSelects = function () {
        if (!handSide || manualMix) return;
        var bar = $('.kaching-bundles__bar--selected', box); if (!bar) return;
        $$('select.kaching-bundles__bar-variant-select', bar).forEach(function (s) {
          var opt = Array.prototype.filter.call(s.options, function (o) { return sideOf(o.value) === handSide; })[0];
          if (opt && s.value !== opt.value) { s.value = opt.value; s.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      };
      on(box, 'hdzb:change', function (e) {
        if (!e.target || !e.target.hasAttribute || !e.target.hasAttribute('data-hand')) return;
        handSide = sideOf(groupValue(e.target)); manualMix = false;
        setTimeout(syncSelects, 80); setTimeout(syncSelects, 400); /* after Kaching has followed input[name=id] */
      });
      on(box, 'change', function (e) {
        var s = e.target;
        if (!e.isTrusted || !s || s.tagName !== 'SELECT' || String(s.className).indexOf('kaching-bundles__bar-variant-select') < 0) return;
        manualMix = true;
      }, true);
      var kroot = $('kaching-bundle', box);
      if (kroot && window.MutationObserver) {
        var mt = null;
        new MutationObserver(function () {
          clearTimeout(mt);
          mt = setTimeout(function () { var bar = $('.kaching-bundles__bar--selected', box); if (bar && bar !== lastBar) { lastBar = bar; manualMix = false; syncSelects(); } }, 90);
        }).observe(kroot, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
      }
    }

    /* Kaching add-on rows (rod / line): the whole row toggles the add-on (the app only listens on its small checkbox and
       text; its image link would open the product in a new tab — bad inside the Facebook browser) */
    if (mode === 'kaching') {
      on(box, 'click', function (e) {
        var up = e.target && e.target.closest ? e.target.closest('.kaching-bundles__upsell') : null;
        if (!up || !box.contains(up)) return;
        var cb = $('.kaching-bundles__upsell__checkbox', up);
        if (!cb) return; /* add-on of a tier that is not selected: let the click select that tier */
        if (e.target.closest('.kaching-bundles__upsell__checkbox, .kaching-bundles__upsell__text')) return; /* the app handles these itself */
        e.preventDefault(); e.stopPropagation();
        cb.click();
      }, true);
    }

    /* add to cart */
    function showErr(msg) { if (!err) return; err.classList.add('is-on'); var t = $('[data-hdzp-err-text]', err); if (t) t.textContent = msg || 'Something went wrong. Tap once more.'; }
    function hideErr() { if (err) err.classList.remove('is-on'); }
    function busy(state) { if (!btn) return; btn.classList.toggle('is-busy', state); if (state) { btn.setAttribute('aria-busy', 'true'); btn.innerHTML = btn.getAttribute('data-busy-text') || 'Adding…'; } else { btn.removeAttribute('aria-busy'); btn.innerHTML = labelDefault; } }
    /* Kaching: the widget owns the payload. We never build it: the form's own FormData (variant id + the hidden
       properties[__kaching_*] inputs the widget injects) goes to /cart/add.js through window.fetch, where Kaching's cart
       interceptor merges it into the bundle lines. Doing the fetch ourselves (instead of letting Kaching's document-level
       submit handler post the form and navigate to /cart) keeps the UpCart drawer flow. */
    function kachingReady() { return !!box.querySelector('kaching-bundle .kaching-bundles__bar'); }
    function waitKaching(ms) {
      return new Promise(function (res) { var t0 = Date.now(); (function chk() { if (kachingReady() || Date.now() - t0 > ms) res(kachingReady()); else setTimeout(chk, 150); })(); });
    }
    var BACKOFF = [5000, 15000, 45000];
    function postForm(tries) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          return r.text().then(function (txt) {
            var j = null; try { j = JSON.parse(txt); } catch (e2) { }
            if (r.status === 429 && (tries || 0) < BACKOFF.length) return new Promise(function (res) { setTimeout(res, BACKOFF[tries || 0]); }).then(function () { return postForm((tries || 0) + 1); });
            if (!r.ok) { var er = new Error((j && (j.description || j.message)) || ('HTTP ' + r.status)); er.status = r.status; throw er; }
            return j;
          });
        });
    }
    if (form && mode === 'kaching') {
      on(form, 'submit', function (e) {
        e.preventDefault(); hideErr();
        if (btn && btn.classList.contains('is-busy')) return;
        busy(true);
        waitKaching(5000).then(function (ready) {
          box.setAttribute('data-kaching-ready', ready ? 'true' : 'false');
          return postForm(0);
        }).then(function () {
          var h = H();
          var refresh = (h && h.cart) ? h.cart.get().catch(function () { }) : Promise.resolve();
          return refresh.then(function () {
            try { if (typeof window.upcartRefreshCart === 'function') { var p = window.upcartRefreshCart(); if (p && p.then) return p.catch(function () { }); } } catch (e3) { }
          }).then(function () {
            busy(false);
            box.dispatchEvent(new CustomEvent('hdzp:added', { bubbles: true, detail: { box: box, mode: mode } }));
            if (h && h.cart) h.cart.open(); else window.location.href = '/cart';
          });
        }).catch(function (er) {
          busy(false);
          showErr(er && er.status === 429 ? 'The store is busy for a moment. Tap once more in a few seconds.' : ((er && er.message) || 'Could not add to cart. Tap once more.'));
        });
      });
    }
    if (form && mode !== 'kaching') {
      /* UpCart intercepts /cart/add FORM submits itself (capture phase) and posts the form as-is → one unit, i.e. no BOGO.
         A window-capture listener runs before any document listener, so our add (two units for BOGO, the stepper quantity for
         plain products) always wins; UpCart still opens because it also watches /cart/add.js fetches. */
      var inFlight = false;
      var doAdd = function () {
        hideErr();
        var h = H(); if (!h || !h.cart) { form.submit(); return; }
        var v1 = currentVariant(); if (!v1) { showErr('Please choose your options.'); return; }
        var items;
        if (mode === 'bogo') {
          if (isMix()) { var vL = findVariant(selectedOptions('left')) || v1; items = (vL.id === v1.id) ? [{ id: v1.id, quantity: 2 }] : [{ id: v1.id, quantity: 1 }, { id: vL.id, quantity: 1 }]; }
          else items = [{ id: v1.id, quantity: 2 }];
        } else {
          var q = form.querySelector('input[name="quantity"]'); var qty = q ? Math.max(1, Number(q.value) || 1) : 1;
          items = [{ id: v1.id, quantity: qty }];
        }
        if (inFlight) return;
        busy(true);
        var attempt = function (n) {
          return h.cart.add(items, { open: true, toast: false }).catch(function (er) {
            if (er && er.status === 429 && n < BACKOFF.length) return new Promise(function (res) { setTimeout(res, BACKOFF[n]); }).then(function () { return attempt(n + 1); });
            throw er;
          });
        };
        inFlight = true;
        attempt(0).then(function () { inFlight = false; busy(false); box.dispatchEvent(new CustomEvent('hdzp:added', { bubbles: true, detail: { box: box, mode: mode, items: items } })); })
          .catch(function (er) { inFlight = false; busy(false); showErr(er && er.status === 429 ? 'The store is busy for a moment. Tap once more in a few seconds.' : ((er && er.message) || 'Could not add to cart. Tap once more.')); });
      };
      on(window, 'click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('[data-hdzp-atc]') : null;
        if (!b || !form.contains(b) || b.disabled) return;
        e.preventDefault(); e.stopImmediatePropagation(); doAdd();
      }, true);
      on(window, 'submit', function (e) { if (e.target !== form) return; e.preventDefault(); e.stopImmediatePropagation(); doAdd(); }, true);
      on(form, 'submit', function (e) { e.preventDefault(); doAdd(); });
    }
    apply('init');
    /* deep link ?variant=… → preselect (top box only) */
    try {
      var vid = new URL(window.location.href).searchParams.get('variant');
      if (vid && data && !box.hasAttribute('data-repeat')) {
        var pv = data.variants.filter(function (x) { return String(x.id) === String(vid); })[0];
        if (pv) {
          groups.forEach(function (gEl) {
            var idx = Number(gEl.getAttribute('data-index')), want = pv.opts[idx];
            if (gEl.tagName === 'SELECT') { gEl.value = want; }
            else { var o = $$('[role="radio"]', gEl).filter(function (x) { return x.getAttribute('data-value') === want; })[0]; if (o && !o.classList.contains('is-on')) o.click(); }
          });
          apply('init'); syncGallery(pv);
        }
      }
    } catch (e) { }
  };

  /* ---------------- sticky bar: shown whenever the buy button is off screen (above or below) ---------------- */
  P.initSticky = function (bar) {
    if (bar.__hdzp) return; bar.__hdzp = true;
    var host = bar.parentNode;
    if (host && host.hasAttribute && host.hasAttribute('data-hdzp-sticky-host')) { document.body.appendChild(host); }
    else if (bar.parentNode !== document.body) document.body.appendChild(bar);
    var target = bar.getAttribute('data-target') ? $(bar.getAttribute('data-target')) : null;
    if (!target) { bar.classList.add('is-on'); document.body.classList.add('hdzb-has-sticky'); return; }
    var anchor = $('[data-hdzp-atc]', target) || target;
    var tick = false;
    function upd() {
      var r = anchor.getBoundingClientRect();
      var zoomOpen = zoom && $('.hdzp-zoom.is-on');
      /* phones: whenever the buy button is off screen (above OR below — the first screen gets the CTA too);
         desktop (≥990): only after the buy box has scrolled past (the box sits beside the gallery on the first screen) */
      var desk = window.matchMedia && window.matchMedia('(min-width: 990px)').matches;
      var show = !zoomOpen && (r.bottom < 0 || (!desk && r.top > window.innerHeight));
      bar.classList.toggle('is-on', show); document.body.classList.toggle('hdzb-has-sticky', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      tick = false;
    }
    on(window, 'scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    on(window, 'resize', debounce(upd, 150));
    upd(); setTimeout(upd, 700);
    var a = $('[data-hdzp-sticky-cta]', bar);
    /* land on the decision point (hand control → tiers → button), not on the intro at the top of the box */
    if (a) on(a, 'click', function (e) {
      e.preventDefault(); e.stopPropagation(); /* hdzb.js's document-level smooth-anchor handler would scroll to the box top instead */
      var dest = $('.hdzp-opts', target) || $('[data-hdzp-offer]', target) || $('[data-hdzp-form]', target) || target;
      var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--hdzb-header-h'), 10) || 0;
      var top = dest.getBoundingClientRect().top + window.pageYOffset - hh - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  };

  /* ---------------- recommendations (Section Rendering API) ---------------- */
  P.initRecs = function (box) {
    if (box.__hdzp) return; box.__hdzp = true;
    var url = box.getAttribute('data-url'); if (!url || box.children.length) return;
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-hdzp-recs]');
      if (!fresh || !fresh.children.length) return;
      box.innerHTML = fresh.innerHTML;
      var sec = box.closest('section'); if (sec) sec.removeAttribute('hidden');
      var h = H(); if (h && h.init) h.init(box);
    }).catch(function () { });
  };

  /* ---------------- natural-ratio content videos ---------------- */
  on(document, 'loadedmetadata', function (e) {
    var v = e.target; if (!v || v.tagName !== 'VIDEO' || !v.videoWidth) return;
    var box = v.closest && v.closest('.hdzp-vid'); if (box && !box.hasAttribute('data-ar-lock')) box.style.setProperty('--ar', v.videoWidth + ' / ' + v.videoHeight);
  }, true);

  function paintSticky() {
    $$('[data-hdzp-sticky-price][data-cents]').forEach(function (el) { el.textContent = money(Number(el.getAttribute('data-cents'))); });
    $$('[data-hdzp-sticky-was][data-cents]').forEach(function (el) { var c = Number(el.getAttribute('data-cents')); if (c > 0) el.textContent = money(c); else el.style.display = 'none'; });
  }

  P.init = function (scope) {
    scope = scope || document;
    $$('[data-hdzp-gallery]', scope).forEach(P.initGallery);
    $$('[data-hdzp-buy]', scope).forEach(P.initBuy);
    $$('[data-hdzp-sticky]', scope).forEach(P.initSticky);
    $$('[data-hdzp-recs]', scope).forEach(P.initRecs);
    paintSticky();
  };
  function boot() {
    P.init(document);
    on(document, 'shopify:section:load', function (e) { if (window.HDZB && window.HDZB.init) window.HDZB.init(e.target); P.init(e.target); });
  }
  window.HDZP = P;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
